module.exports = __webpack_public_path__ + "media/img/auth-side-cover-brand-front-02-01-254c218ee7fdf4aaf2d6fd7ad3864799.svg";